import script from "./BadAttendances.vue?vue&type=script&setup=true&lang=js"
export * from "./BadAttendances.vue?vue&type=script&setup=true&lang=js"

import "./BadAttendances.vue?vue&type=style&index=0&id=4d346484&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d346484"]])

export default __exports__